'use client';

import { useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import Image from 'next/image';

type PortfolioLogo = {
  id: number;
  logo: string;
  client_name: string;
};

export default function CompanyLogosSlider() {
  const [logos, setLogos] = useState<PortfolioLogo[]>([]);

  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      align: 'start',
      slidesToScroll: 1,
    },
    [
      Autoplay({
        delay: 2200,
        stopOnInteraction: false,
      }),
    ]
  );

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await fetch('/api/portfolios');
        if (!res.ok) return;

        const data = await res.json();
        if (!mounted) return;

        const filtered = data
          .filter((p: any) => p.logo)
          .map((p: any) => ({
            id: p.id,
            logo: p.logo,
            client_name: p.client_name,
          }));

        setLogos(filtered);
      } catch {
        // fail silently
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  if (!logos.length) return null;

  return (
    <div data-component-id="src\components\common\CompanyLogosSlider.tsx:64:4" data-component-path="src\components\common\CompanyLogosSlider.tsx" data-component-line="64" data-component-end-line="81" data-component-file="CompanyLogosSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20overflow-hidden%22%7D" className="w-full overflow-hidden" ref={emblaRef}>
      <div data-component-id="src\components\common\CompanyLogosSlider.tsx:65:6" data-component-path="src\components\common\CompanyLogosSlider.tsx" data-component-line="65" data-component-end-line="80" data-component-file="CompanyLogosSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%22%7D" className="flex items-center">
        {logos.map((item) => (
          <div data-component-id="src\components\common\CompanyLogosSlider.tsx:67:10" data-component-path="src\components\common\CompanyLogosSlider.tsx" data-component-line="67" data-component-end-line="78" data-component-file="CompanyLogosSlider.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-%5B0_0_25%25%5D%20sm%3Aflex-%5B0_0_20%25%5D%20md%3Aflex-%5B0_0_16%25%5D%20px-4%22%7D"
            key={item.id}
            className="flex-[0_0_25%] sm:flex-[0_0_20%] md:flex-[0_0_16%] px-4"
          >
            <Image data-component-id="src\components\common\CompanyLogosSlider.tsx:71:12" data-component-path="src\components\common\CompanyLogosSlider.tsx" data-component-line="71" data-component-end-line="77" data-component-file="CompanyLogosSlider.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20h-auto%20max-h-%5B50px%5D%20object-contain%20opacity-70%20hover%3Aopacity-100%20transition%22%7D"
              src={item.logo}
              alt={item.client_name || 'Client logo'}
              width={180}
              height={50}
              className="w-full h-auto max-h-[50px] object-contain opacity-70 hover:opacity-100 transition"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
